module.exports = __webpack_public_path__ + "static/media/volume.d542fde6.svg";